export class RentalProdSelectionTimings {
    startSoapDate: string | null;
    durationIdentifier: string | null;
    pickUpTimeId: number | null;

    allBookingTimeParametersAreSet(): boolean {
        return this.durationIdentifier != null
            && this.pickUpTimeId != null
            && this.startSoapDate != null;
    }
}